"use strict";

import { CURRENCY_LABEL } from "../components/common";

export function initProductDetailsThumbnailCarouselSwiper() {
    const thumbnails = $('.product-details .product-details__thumbnail');

    const getDirection = () => {
        return window.innerWidth >= 768 ? 'vertical' : 'horizontal';
    }

    const getEnable = () => {
        let enabled;
        if (window.innerWidth < 375) {
            enabled = thumbnails.length > 3;
        } else {
            enabled = thumbnails.length > 4;
        }
        return enabled;
    }

    /**
     * deprecated
     * @returns {number}
     */
    const getSlidesPerGroup = () => {
        let slidesPerGroup;
        if (window.innerWidth < 375) {
            slidesPerGroup = getEnable() ? 1 : 3;
        } else {
            slidesPerGroup = getEnable() ? 1 : 4;
        }
        return slidesPerGroup;
    }

    const swiper = new Swiper(".product-details .product-details__thumbnails", {
        loop: getEnable(),
        loopAdditionalSlides: 1,
        loopFillGroupWithBlank: false,
        centerInsufficientSlides: true,
        resizeObserver: true,
        updateOnWindowResize: true,
        watchOverflow: true,
        freeModeSticky: true,
        slidesPerView: 3,
        spaceBetween: 15,
        direction: getDirection(),
        enabled: getEnable(),
        navigation: {
            prevEl: ".swiper-navigation--prev",
            nextEl: ".swiper-navigation--next",
        },
        on: {
            resize: () => {
                swiper.changeDirection(getDirection());
                const enabled = getEnable();
                if (enabled) {
                    swiper.enable();
                } else {
                    swiper.disable();
                }

                if (swiper.params.loop !== enabled){
                    swiper.params.loop = enabled;
                    if (enabled) {
                        swiper.loopCreate();
                    } else {
                        swiper.loopDestroy();
                    }
                }
            },
        },
        breakpoints: {
            // Sync with css breakpoints
            375: {
                slidesPerView: 4,
                centerInsufficientSlides: true,
            },
            768: {
                slidesPerView: 4,
                centerInsufficientSlides: false,
            }
        },

    });
}

export function initProductDetailsImagePreview() {
    $('.product-details .product-details__thumbnail').on('click', changePreviewMedia);
    $('.product-details .product-details__preview').zoom();
}

export function changePreviewMedia() {
    $('.product-details__preview video').each((index, item) => {
        item.pause();
    });
    $(this).siblings().removeClass('active');

    $(this).addClass('active');
    $('.product-details__preview')
        .removeClass('active')
        .eq($(this).attr('data-thumbnail-index'))
        .addClass('active')
        .find('video')
        .each((index, item) => {
            item.play();
        });
}

export function toggleCollapseProductSpecsGroup() {
    $(this).parent().toggleClass('open');
}

export function togglePurchaseInformationTab() {
    $(this).parent().find('dt').removeClass('active');
    $(this).addClass('active');
}

export function onProductSizeChange() {
    populateSelectedSizeDataIntoAddToCartButton.call(this);
    updateProductPriceForSelectedSize.call(this);
    updateProductWeightForSelectedSize.call(this);
    updateDiamondVerificationValues.call(this);
    checkAndPopulateRemainingQuantityIntoAddToButton();
    updateBadgesVisibility();
}

export function populateSelectedSizeDataIntoAddToCartButton() {
    const selectedSizeOption = $(this).find(":selected");
    const addToCartButton = $('.product-details button.add-to-cart');
    addToCartButton.attr('data-idproduct', selectedSizeOption.get(0)?.value);
    addToCartButton.attr('data-qty', selectedSizeOption.attr('data-qty'));
    addToCartButton.attr('data-is-new', selectedSizeOption.attr('data-is-new'));
}

export function updateProductPriceForSelectedSize() {
    const selectedSizeOption = $(this).find(":selected");
    if (!selectedSizeOption.length) {
        return;
    }
    const hasSale = selectedSizeOption.attr('data-discount') && selectedSizeOption.attr('data-sale-price');
    const price = `${selectedSizeOption.attr('data-price')} ${CURRENCY_LABEL}`;
    const salePrice = `${selectedSizeOption.attr('data-sale-price')} ${CURRENCY_LABEL}`;
    const discount = `-${selectedSizeOption.attr('data-discount')} %`;

    if (hasSale) {
        $('.product-price__current-price').text(salePrice);
        $('.product-price__old-price').text(price).show();
        $('.product-price__badge--sale').text(discount).show();
    } else {
        $('.product-price__current-price').text(price);
        $('.product-price__old-price').text('').hide();
        $('.product-price__badge--sale').text('').hide();
    }
}

export function updateProductWeightForSelectedSize() {
    const selectedSizeOption = $(this).find(":selected");
    if (!selectedSizeOption.length) {
        return;
    }
    const weight = selectedSizeOption.attr('data-weight');
    $('.product-details .product-specs .product-weight').text(weight);
}

export function updateDiamondVerificationValues() {
    if (!$('#diamond-verification-modal').length) {
        return;
    }
    const selectedSizeOption = $(this).find(":selected");
    if (!selectedSizeOption.length) {
        return;
    }
    const hrdantwerp = selectedSizeOption.attr('data-hrdantwerp');
    if (!hrdantwerp) {
        return;
    }
    const href = `https://my.hrdantwerp.com/Download/GetGradingReportPdf/?reportNumber=${hrdantwerp}&printDocumentType=MiniJewelCert`;
    $('.modal.diamond-verification .diamond-id > span').text(hrdantwerp);
    $('.modal.diamond-verification .diamond-id [data-copy-to-clipboard]').attr('data-copy-to-clipboard', hrdantwerp);
    $('.modal.diamond-verification .download-pdf').attr('href', href);
}

export function onAddProductToCart() {
    checkAndPopulateRemainingQuantityIntoAddToButton();
}

export function checkAndPopulateRemainingQuantityIntoAddToButton() {
    const button = $('.product-details button.add-to-cart');
    if (!button.length) {
        return;
    }
    if (+button.attr('data-qty') === 0) {
        button.prop('disabled', true);
        button.text('Lipsește in stoc');
        return;
    } else if (+button.attr('data-qty') === -1) {
        return;
    }
    const productId = button.attr('data-idproduct');
    const qtyInBasket = $(`#cart-modal li[data-idproduct="${productId}"]`).map(function(){
        return +$(this).attr('data-qty');
    }).get().reduce((a, b) => a + b, 0);
    const remainingQuantity = +button.attr('data-qty') - qtyInBasket;
    // console.log('Qty In Basket', qtyInBasket, productId, remainingQuantity);
    button.attr('data-remaining-qty', remainingQuantity);
    if (remainingQuantity <= 0) {
        button.prop('disabled', true);
        button.text('Ultima bucata este in coș');
    } else {
        button.prop('disabled', false);
        button.html('<i class="skl-icon-bag"></i> Adaugă În Coș');
    }
}

export function updateBadgesVisibility() {
    const button = $('.product-details button.add-to-cart');
    if (!button.length) {
        return;
    }

    if (+button.attr('data-qty') ===  1) {
        $('.product-details__badge--last').addClass('active');
    } else {
        $('.product-details__badge--last').removeClass('active');
    }

    if (button.attr('data-is-new') === 'true') {
        $('.product-details__badge--new').addClass('active');
    } else {
        $('.product-details__badge--new').removeClass('active');
    }
}

export function playPauseVideoPreview() {
    this.paused ? this.play() : this.pause();
}

export function initProductSetCarouselSwiper() {
    const carousels = $(".products-set__container > .swiper-container");

    carousels.each((index, carousel) => {
        const productsLength = $(carousel).find('.products-set__product').length;
        if (productsLength <= 4) {
            console.log(`Product set has ${productsLength} items, and carousel is not needed`);
            return;
        }

        const swiper = new Swiper(carousel, {
            loop: false,
            loopAdditionalSlides: 0,
            resizeObserver: true,
            updateOnWindowResize: true,
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 12*3,
            navigation: {
                prevEl: ".swiper-navigation--prev",
                nextEl: ".swiper-navigation--next",
            },
            slideClass: 'swiper-slide',
        });
    });
}

export function initProductVariantsCarouselSwiper() {
    const carousels = $(".product-variants__container > .swiper-container");

    carousels.each((index, carousel) => {
        const productsLength = $(carousel).find('.product-variants__product').length;
        if (productsLength <= 6) {
            console.log(`Product variants has ${productsLength} items, and carousel is not needed`);
            return;
        }

        const swiper = new Swiper(carousel, {
            loop: false,
            loopAdditionalSlides: 0,
            resizeObserver: true,
            updateOnWindowResize: true,
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 12*3,
            navigation: {
                prevEl: ".swiper-navigation--prev",
                nextEl: ".swiper-navigation--next",
            },
            slideClass: 'swiper-slide',
        });
    });
}

export default function init() {
    if (!$('.product-page').length) {
        return;
    }

    initProductDetailsThumbnailCarouselSwiper();
    initProductDetailsImagePreview();
    initProductSetCarouselSwiper();
    initProductVariantsCarouselSwiper();
    checkAndPopulateRemainingQuantityIntoAddToButton();
    updateBadgesVisibility();

    $('.product-details .product-specs__group--collapsible .product-specs__header').on('click', toggleCollapseProductSpecsGroup);
    $('.product-details .purchase-information dt').on('click', togglePurchaseInformationTab);
    $('.product-details select.product-size__selector').on('change', onProductSizeChange);
    $('.product-details button.add-to-cart').on('click', onAddProductToCart);
    $('.product-details .product-details__preview video').on('click', playPauseVideoPreview);

    document.addEventListener("sklCartUpdated", function(event) {
        // console.log('sklCartUpdated', event.detail);
        checkAndPopulateRemainingQuantityIntoAddToButton();
    });
}
